import { AppShell, ActionIcon, Group } from '@mantine/core';
import { useUnit } from 'effector-react';
import { X, Menu, PanelRightClose, PanelRightOpen } from 'lucide-react';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { GameAside } from 'entities/game';
import { ViewerMenu } from 'entities/viewer';
import { cashierLayoutModel } from '../../model';
import { CashierLayoutNavList } from '../cashier-layout-nav-list';
import { CashierLayoutOverlay } from '../cashier-layout-overlay';
import cls from './cashier-layout.module.scss';

export const CashierLayout = ({ children }: PropsWithChildren) => {
	const { t } = useTranslation();

	const openedGames = useUnit(cashierLayoutModel.$openedGames);

	const asideSwitcher = useUnit(cashierLayoutModel.asideSwitcher);

	const navbarSwitcher = useUnit(cashierLayoutModel.navbarSwitcher);

	return (
		<AppShell
			header={{ height: 60 }}
			navbar={{
				width: 300,
				breakpoint: 'lg',
				collapsed: { mobile: !navbarSwitcher.active, desktop: !navbarSwitcher.active },
			}}
			aside={{
				width: 300,
				breakpoint: 'lg',
				collapsed: {
					mobile: !asideSwitcher.active,
					desktop: !asideSwitcher.active,
				},
			}}
			className={cls.cashierLayoutRoot}
		>
			<AppShell.Header className={cls.cashierLayoutHeader}>
				<div className={cls.cashierLayoutHeaderLeft}>
					<ActionIcon
						data-test-id='cashier-layout-navbar-toggle'
						className={cls.cashierLayoutBurger}
						hiddenFrom='sm'
						variant='outline'
						onClick={navbarSwitcher.toggle}
					>
						{navbarSwitcher.active ? (
							<X className={cls.cashierLayoutAsideIcon} />
						) : (
							<Menu className={cls.cashierLayoutAsideIcon} />
						)}
					</ActionIcon>
					<h3 className={cls.cashierLayoutTitle}>{t('cashier-layout.title')}</h3>
				</div>
				<CashierLayoutNavList visibleFrom='sm' />
				<Group gap={8}>
					<ViewerMenu />
					<ActionIcon
						data-test-id='cashier-layout-aside-toggle'
						className={cls.cashierLayoutBurger}
						disabled={!openedGames}
						onClick={asideSwitcher.toggle}
					>
						{asideSwitcher.active ? (
							<PanelRightClose className={cls.cashierLayoutBurgerIcon} />
						) : (
							<PanelRightOpen className={cls.cashierLayoutBurgerIcon} />
						)}
					</ActionIcon>
				</Group>
			</AppShell.Header>
			<AppShell.Navbar className={cls.cashierLayoutNavbar}>
				<CashierLayoutNavList />
			</AppShell.Navbar>
			{children}
			<CashierLayoutOverlay hiddenFrom='lg' />
			{openedGames && (
				<AppShell.Aside className={cls.cashierLayoutAside}>
					<GameAside />
				</AppShell.Aside>
			)}
		</AppShell>
	);
};
